import {
  CREATE_MISSION_CONDITIONS_FIXED_CACHE_KEY,
  CREATE_MISSION_FIXED_CACHE_KEY
} from '@bo-constants/missions';
import {
  useCreateMissionConditionsMutation,
  useCreateMissionMutation
} from '@bo-services/promotionsApi';
import { CreateMissionStepSummary } from '@bo-components/missions/CreateMissionStepSummary';
import { FormActionButtons } from '@library/components/buttons';
import type { MissionEventInput } from '@library/types/missions';
import { MissionEventsFormInputs } from '@bo-components/missions/MissionEventsFormInputs';
import { useState } from 'react';
import { useSteps } from '@library/components/progress/Steps';

export const MissionEventsForm = () => {
  const [inputs, setInputs] = useState<MissionEventInput[]>([
    { event_definition_id: '', occurrences: 1 }
  ]);
  const { setCurrentStep, setStepComplete } = useSteps();
  const [, { data }] = useCreateMissionMutation({
    fixedCacheKey: CREATE_MISSION_FIXED_CACHE_KEY
  });
  const [createMissionConditions] = useCreateMissionConditionsMutation({
    fixedCacheKey: CREATE_MISSION_CONDITIONS_FIXED_CACHE_KEY
  });

  const handleBack = () => {
    setCurrentStep('details');
  };

  const handleSaveAndContinue = async () => {
    if (data?.challenge) {
      const missionConditions = inputs.map(
        ({ event_definition_id, occurrences }) => ({
          challenge_id: data.challenge.id,
          event_definition_id,
          occurrences
        })
      );

      await createMissionConditions({
        challenge_conditions: missionConditions
      });

      setStepComplete();
      setCurrentStep('conditions');
    }
  };

  return (
    <>
      <CreateMissionStepSummary mission={data?.challenge} />
      <div className="flex min-h-[30vh] flex-col gap-4">
        <MissionEventsFormInputs inputs={inputs} setInputs={setInputs} />
      </div>
      <FormActionButtons
        primary={{ onClick: handleSaveAndContinue, label: 'Continue' }}
        secondary={{ onClick: handleBack, label: 'Back' }}
      />
    </>
  );
};
